import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";

export const PATH_EMBEDDED = "/embedded";

export const PATH_EMBEDDED_ONBOARDING = `${PATH_EMBEDDED}/onboarding`;
export const PATH_EMBEDDED_DEFAULT_PAYMENT_METHOD = `${PATH_EMBEDDED}/default-payment-method`;
export const PATH_EMBEDDED_DEFAULT_PAYOUT_METHOD = `${PATH_EMBEDDED}/default-payout-method`;
export const PATH_EMBEDDED_MANAGE_PAYOUT_METHOD = `${PATH_EMBEDDED}/manage-payout-method`;
export const PATH_EMBEDDED_MANAGE_PAYOUT_METHOD_ADD = `${PATH_EMBEDDED_MANAGE_PAYOUT_METHOD}/add`;
export const PATH_EMBEDDED_MANAGE_PAYMENT_METHOD = `${PATH_EMBEDDED}/manage-payment-method`;
export const PATH_EMBEDDED_MANAGE_PAYMENT_METHOD_ADD = `${PATH_EMBEDDED_MANAGE_PAYMENT_METHOD}/add`;
export const PATH_EMBEDDED_MANAGE_FUNDING_METHOD = `${PATH_EMBEDDED}/manage-funding-method`;
export const PATH_EMBEDDED_MANAGE_FUNDING_METHOD_ADD = `${PATH_EMBEDDED_MANAGE_FUNDING_METHOD}/add`;
export const PATH_EMBEDDED_PREVIEW_FUNDING_METHOD = `${PATH_EMBEDDED}/preview-funding-method`;

export const PARAMETER_REQUIREMENT_ID = "requirementId";

export const PATH_EMBEDDED_ONBOARDING_REQUIREMENT_DETAILS = `${PATH_EMBEDDED_ONBOARDING}/eligibility-requirements/:${PARAMETER_REQUIREMENT_ID}`;

export const routeHelpersEmbeddedOnboardingRequirementDetails =
  createRouteHelpers(PATH_EMBEDDED_ONBOARDING_REQUIREMENT_DETAILS);

export const PATH_EMBEDDED_COMPLETE_VERIFICATION = `${PATH_EMBEDDED}/complete-verification`;

export const PATH_EMBEDDED_MANAGE_WALLET_CARDS = `${PATH_EMBEDDED}/manage-wallet-cards`;
export const PATH_EMBEDDED_MANAGE_WALLET_CARDS_ORDER_VIRTUAL = `${PATH_EMBEDDED_MANAGE_WALLET_CARDS}/order-virtual`;
export const PATH_EMBEDDED_MANAGE_WALLET_CARDS_ORDER_PHYSICAL = `${PATH_EMBEDDED_MANAGE_WALLET_CARDS}/order-physical`;
export const PATH_EMBEDDED_MANAGE_WALLET_CARDS_CONFIRM_PHYSICAL = `${PATH_EMBEDDED_MANAGE_WALLET_CARDS_ORDER_PHYSICAL}/confirm`;

export const PARAMETER_CARD_ID = "cardId";

export const PATH_EMBEDDED_MANAGE_WALLET_CARDS_CARD = `${PATH_EMBEDDED_MANAGE_WALLET_CARDS}/card/:${PARAMETER_CARD_ID}`;

export const routeHelpersEmbeddedManageWalletCardsCard = createRouteHelpers(
  PATH_EMBEDDED_MANAGE_WALLET_CARDS_CARD
);
